import { ValueFormatterParams } from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers'

export const columns = [
  {
    headerName: 'Barcode',
    field: 'barcode',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Store',
    field: 'store',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Aisle',
    field: 'aisle',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Shelf',
    field: 'shelf',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Facing',
    field: 'facing',
    valueFormatter: (params: ValueFormatterParams) => params.value || '-',
  },
  {
    headerName: 'Updated At',
    field: 'updatedAt',
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value) : '-',
  },
  {
    headerName: 'Created At',
    field: 'createdAt',
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value) : '-',
  },
]

export const PRICE_LABEL_FORM_FIELDS = {
  STORE_ID: {
    key: 'storeId',
    label: 'Store ID',
  },
  BARCODE: {
    key: 'barcode',
    label: 'Barcode',
  },
  STATUS: {
    key: 'status',
    label: 'Status',
  },
}

export const FILTER_FIELD_PRICE_LABELS = 'priceLabelFilters'
